export const IS_BROWSER = typeof window !== "undefined";

export const PAGES = [
  { name: "Home", path: "/", dark: true },
  { name: "About Us", path: "/about", dark: true },
  { name: "Register", path: "/register", dark: true },
  { name: "Contact Us", path: "/contact", dark: true },
  // { name: "Modules", path: "/modules", dark: true },
];

export const AWS_S3_BASE_URL = "https://eyes-of-hope.s3.amazonaws.com/";

export const colors = {
  primary: "#14B2B6",
};
